import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
  TYPE_INSTANCE2,
  TYPE_INSTANCE3,
  TYPE_INSTANCE4,
} from "App/constants"
import {
  InputAsyncOptionMaster,
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui"
import { Grid } from "@material-ui/core"
import { useState } from "react"
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  isNull,
  titleModal,
} from "App/utils/helpers"
import { useSelectOption } from "App/hooks"
import { LIST_URL_WAREHOUSE } from "utils/warehouse"
import { LIST_URL_BILLING } from "utils/billing"

export const RESET_STATE_KAMAR = {
  id: "",
  name: "",
  ruang_id: "",
  id_gudang_farmasi: "",
  name_gudang_farmasi: "",
  id_fasilitas: "",
  name_fasilitas: "",
}

export const urlGet = "/bed/listkamar"
export const urlAdd = "/bed/addkamar"
export const urlUpdate = "/bed/updatekamar"
export const urlDelete = "/bed/deletekamar"

export const deleteKamarById = async (id) => {
  try {
    await instance2.post(
      urlDelete,
      {},
      {
        headers: {
          idkamar: id,
        },
      },
    )
    return {
      state: true,
      message: "Berhasil menghapus data",
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "gudang_farmasi",
    disablePadding: false,
    label: "GUDANG FARMASI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "fasilitas",
    disablePadding: false,
    label: "FASILITAS",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const ModalForm = ({
  setShowModal,
  formData,
  setFormData,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)

  const add = async () => {
    return instance2.post(urlAdd, {
      ...formData,
    })
  }

  const update = () => {
    return instance2.post(
      urlUpdate,
      {
        ...formData,
      },
      {
        headers: {
          idkamar: formData.id,
        },
      },
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError("Nama tidak boleh kosong")
    } else {
      try {
        if (formData.id === "") {
          await add()
          defaultToastSuccess("Berhasil menambah data")
        } else if (formData.id !== "") {
          await update()
          defaultToastSuccess("Berhasil mengubah data")
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        setFormData(RESET_STATE_KAMAR)
        setShowModal(false)
        setNewData()
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        defaultToastError(error?.response?.data?.message)
      }
    }
  }

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const ruang = useSelectOption(false, "/bed/listruang", TYPE_INSTANCE2)

  const gudangUtama = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterGudangPBF.getGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "data",
  )

  const preLoadDataBarang = async (inputValue) => {
    const res = await fetchData(
      TYPE_INSTANCE3,
      LIST_URL_BILLING.fasilitas.list,
      "body",
      {
        params: {
          qword: isNull(inputValue) ? "" : inputValue,
        },
      },
    )

    if (res) {
      const data = []
      res.map((item) => {
        return data.push({
          value: item["id"],
          label: item[("id", "nama")],
        })
      })

      return data
    } else {
      return []
    }
  }

  return (
    <Modal
      title={`${titleModal(formData.id)} Kamar`}
      show={setShowModal}
      width="30%"
    >
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name="name"
              label="Nama"
              id="name"
              value={formData.name}
              onChange={handleChange("name")}
              placeholder="Nama"
            />
          </Grid>
          <Grid item sm={12}>
            <InputOptionMaster
              name="ruang_id"
              label="RUANG"
              id="ruang_id"
              withSearch={false}
              data={ruang}
              value={formData.ruang_id}
              onChange={handleChange("ruang_id")}
            />
          </Grid>
          <Grid item sm={12}>
            <InputOptionMaster
              name="id_gudang_farmasi"
              label="GUDANG"
              id="id_gudang_farmasi"
              withSearch={true}
              data={gudangUtama}
              value={formData.id_gudang_farmasi}
              labelValue={formData.name_gudang_farmasi}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    id_gudang_farmasi: null,
                    name_gudang_farmasi: null,
                  })
                } else {
                  setFormData({
                    ...formData,
                    id_gudang_farmasi: e?.value,
                    name_gudang_farmasi: e?.label,
                  })
                }
              }}
            />
          </Grid>
          <Grid item sm={12}>
            <InputAsyncOptionMaster
              label="Fasilitas"
              name="id_fasilitas"
              id="id_fasilitas"
              needParse={false}
              withSearch={true}
              data={[]}
              loadOptions={preLoadDataBarang}
              defaultData={formData.id_fasilitas}
              value={formData.id_fasilitas}
              labelValue={formData.name_fasilitas}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    id_fasilitas: null,
                    name_fasilitas: null,
                  })
                } else {
                  setFormData({
                    ...formData,
                    id_fasilitas: e.value,
                    name_fasilitas: e.label,
                  })
                }
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  )
}
